var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campaigns-index"},[(_vm.$can('list_personal_campaigns'))?_c('div',[_c('CampaignInsights',{attrs:{"is_admin":0}}),_c('div',{staticClass:"my-10"}),_c('CampaignsAdvertisersTable')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }